import React from 'react'

const ModalDetalleProjects = () => {
  return (
    <div>
      
    </div>
  )
}

export default ModalDetalleProjects
